import { EndpointUrl } from 'api/endpoint';
import { useFetcher } from 'api/fetcher';
import { useWorkspaceId } from 'api/providers/workspaceProvider';

export interface Plugin {
  id: string;
  name: string;
  version: string;
  is_ready: boolean;
}

export interface PluginRunRequest {
  plugin_version_id: string;
  scope: string;
  user_id: string;
  workspace_id: string;
}

export interface PluginRunResponse {
  result?: any;
  error?: string;
}

export function usePlugins() {
  return useFetcher<Plugin[]>('plugins');
}

export function usePluginActions() {
  const workspaceId = useWorkspaceId();

  return {
    runPlugin: async function (pluginVersionId: string, scope: string) {
      if (!workspaceId) throw new Error('No workspace selected');

      const token = localStorage.getItem('token') || '';
      const response = await fetch(
        `${EndpointUrl}/workspace/${workspaceId}/plugins/run`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-finsight-token': token,
          },
          body: JSON.stringify({
            plugin_version_id: pluginVersionId,
            scope,
            workspace_id: workspaceId,
          }),
        },
      );

      if (!response.ok) {
        throw new Error('Failed to run plugin');
      }

      return (await response.json()) as PluginRunResponse;
    },
  };
}
